import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, testId }) => (
  <p
    data-testid={testId}
    className="mb-5 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-[color:var(--ns-gold)]"
  >
    <span className="h-px w-10 bg-[color:var(--ns-gold)]/60" />
    {children}
  </p>
);
